module.exports = __webpack_public_path__ + "img/about_banner_1.b34de7d8.png";